<template>
  <div class="dx-report-tip">
    <span class="dx-report-tip__icon">
      <icon name="exclamation-triangle" />
    </span>
    <span class="dx-report-tip__text">
      {{ $t('reportTip') }}
    </span>
  </div>
</template>

<script>
import 'vue-awesome/icons/exclamation-triangle'
export default {
  name: 'dx-report-tip'
}
</script>



// WEBPACK FOOTER //
// src/components/DxReportTip.vue